import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import { callApi } from '../../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../../api/constant';
import { PageDetails } from '../../../interfaces/pages';

const Pages: React.FC = () => {
    const [pages, setPages] = useState<PageDetails[]>([]);
    const [loading, setLoading] = useState<boolean>(true); // Track loading state

    useEffect(() => {
        getPages();
    }, []);

    const getPages = async () => {
        try {
            setLoading(true); // Start loading
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + 'pages', { method: 'GET' });
            setPages(response);
        } catch (error: any) {
            console.error('Failed to fetch pages:', error.message);
        } finally {
            setLoading(false); // End loading
        }
    };

    return (
        <Layout>
            <h1 className="app-page-title">Pages</h1>
            <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                <div className="app-card-body">
                    <div className="table-responsive">
                        <table className="table app-table-hover mb-0 text-left">
                            <thead>
                                <tr>
                                    <th className="cell">S.no.</th>
                                    <th className="cell">Navigation Link</th>
                                    <th className="cell">Page Title</th>
                                    <th className="cell">Meta Description</th>
                                    <th className="cell">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td className="text-center" colSpan={5}>Loading pages...</td>
                                    </tr>
                                ) : pages.length === 0 ? (
                                    <tr>
                                        <td className="text-center" colSpan={5}>No pages available to display.</td>
                                    </tr>
                                ) : (
                                    pages.map((page, index) => (
                                        <tr key={page.id}>
                                            <td className="cell">#{index + 1}</td>
                                            <td className="cell"><span className="truncate">{page.slug}</span></td>
                                            <td className="cell">{page.title}</td>
                                            <td className="cell">{page.meta_description}</td>
                                            <td className="cell">
                                                <a className="btn-sm app-btn-secondary" href="#">View</a>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Pages;
